import React from 'react'

/**
 * @param {Object} options
 * @param {boolean} options.initialLoading
 * @param {boolean} options.noSpinner
 */
const withLoading = options => Component => {
  class WithLoading extends React.Component {
    state = { isLoading: options.initialLoading || false }

    startLoading = () => this.setState({ isLoading: true })

    endLoading = () => this.setState({ isLoading: false })

    render() {
      return (
        <Component
          loading={{
            isLoading: this.state.isLoading,
            onLoadingStart: this.startLoading,
            onLoadingEnd: this.endLoading,
          }}
          {...this.props}
        />
      )
    }
  }

  WithLoading.displayName = `withLoading(${Component.displayName || Component.name})`

  return WithLoading
}

export default withLoading



// WEBPACK FOOTER //
// ./src/components/common/withLoadingHOC/withLoadingHOC.js